import { useState, useEffect } from 'react';
import { fetchActionContent } from '../../api/oneApi';

const ActionBlock = () => {
  const [actionContent, setActionContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadActionContent = async () => {
      try {
        const data = await fetchActionContent();
        if (data && data.length > 0) {
          setActionContent(data[0]); // Берем первый активный контент
        }
      } catch (err) {
        console.error('Error loading action content:', err);
        setError('Не удалось загрузить контент акций');
      } finally {
        setLoading(false);
      }
    };

    loadActionContent();
  }, []);

  // Fallback статический контент, если API недоступен
  const renderStaticContent = () => (
    <div className="action-h1-wrapper">
      <div className="heading-h1">
        <h1>Акції</h1>
      </div>
      <div className="action-wrapper">
        <div className="small-wrapper price-gap">
          <div className="heading-h3">
            <h3>Кінотеатр ДРУЖБА з 1 травня 2025р.</h3>
          </div>
          {/* Статический контент как fallback */}
          <div className="price-info">
            <p className="price-name">Вартість квитків</p>
            <p className="price-price">120грн</p>
          </div>
          <p className="price-name">Завантаження...</p>
        </div>
      </div>
    </div>
  );

  const renderDynamicContent = () => {
    if (!actionContent) return renderStaticContent();

    return (
      <div className="action-h1-wrapper">
        <div className="heading-h1">
          <h1>{actionContent.title || 'Акції'}</h1>
        </div>

        {/* Основной контент */}
        <div className="action-wrapper">
          <div className="small-wrapper price-gap">
            <div className="heading-h3">
              <h3>{actionContent.subtitle || 'Кінотеатр ДРУЖБА'}</h3>
            </div>
            {actionContent.main_content && (
              <div dangerouslySetInnerHTML={{ __html: actionContent.main_content }} />
            )}
          </div>
        </div>

        {/* Контент о льготах */}
        {actionContent.benefits_content && (
          <div className="action-wrapper">
            <div className="small-wrapper price-gap">
              <div className="heading-h3">
                <h3>Пільги на білети</h3>
              </div>
              <div dangerouslySetInnerHTML={{ __html: actionContent.benefits_content }} />
            </div>
          </div>
        )}

        {/* Контент внимания */}
        {actionContent.attention_content && (
          <div className="action-wrapper">
            <div className="small-wrapper price-gap">
              <div className="heading-h3">
                <h3>Увага!</h3>
              </div>
              <div dangerouslySetInnerHTML={{ __html: actionContent.attention_content }} />
            </div>
          </div>
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <section>
        <div className="wrapper">
          {renderStaticContent()}
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section>
        <div className="wrapper">
          <div className="action-h1-wrapper">
            <div className="heading-h1">
              <h1>Акції</h1>
            </div>
            <div className="action-wrapper">
              <div className="small-wrapper price-gap">
                <p className="price-name">{error}</p>
                {renderStaticContent()}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section>
      <div className="wrapper">
        {renderDynamicContent()}
      </div>
    </section>
  );
};

export default ActionBlock;
